export default __webpack_public_path__ + "static/media/LAS0720.34I-37964_-22242_0.f0f994b8.jpg";